/**
 * Cookie-less site analytics tracker for the marketing pages.
 * Session id lives in sessionStorage (cleared on tab close) — no persistent
 * tracking, no cookies, no consent banner required.
 */
import { api } from "./api";

const SESSION_KEY = "haruki_analytics_session";
const LANDED_KEY = "haruki_analytics_landed";

// Marketing routes we care about. Anything under /app, /agency, /platform,
// /admin, /auth is authenticated area — not tracked.
const MARKETING_PREFIXES = ["/", "/speaking", "/trial", "/start-trial",
                            "/signin", "/demo"];

function isMarketingPath(pathname) {
  if (!pathname) return false;
  return MARKETING_PREFIXES.some(p => pathname === p || pathname.startsWith(p + "/"));
}

function getSessionId() {
  try {
    let s = sessionStorage.getItem(SESSION_KEY);
    if (!s) {
      s = `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem(SESSION_KEY, s);
    }
    return s;
  } catch {
    // Private mode / storage disabled — degrade to a per-page id so events
    // still record (they just won't group into a session).
    return `s_nostore_${Math.random().toString(36).slice(2, 12)}`;
  }
}

function readUtm() {
  try {
    const qs = new URLSearchParams(window.location.search);
    return {
      utm_source: qs.get("utm_source") || undefined,
      utm_medium: qs.get("utm_medium") || undefined,
      utm_campaign: qs.get("utm_campaign") || undefined,
    };
  } catch {
    return {};
  }
}

function isLandingHit() {
  try {
    if (sessionStorage.getItem(LANDED_KEY)) return false;
    sessionStorage.setItem(LANDED_KEY, "1");
    return true;
  } catch { return true; }
}

export function trackPageview(pathname) {
  if (!isMarketingPath(pathname)) return;
  const body = {
    path: pathname,
    referrer: document.referrer || null,
    session_id: getSessionId(),
    is_landing: isLandingHit(),
    ...readUtm(),
  };
  api.post("/track/pageview", body).catch(() => {});
}

export function trackEvent(name, meta) {
  const body = {
    name,
    path: window.location.pathname,
    session_id: getSessionId(),
    meta: meta || {},
  };
  api.post("/track/event", body).catch(() => {});
}
